export default __webpack_public_path__ + "static/media/storx-logo-dark.1a3e040c.svg";